import { render, staticRenderFns } from "./overview-slider.vue?vue&type=template&id=190c163a&"
import script from "./overview-slider.vue?vue&type=script&lang=js&"
export * from "./overview-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports